import { createFileRoute, redirect } from "@tanstack/react-router";

// The Cloud Twins tab was folded into the Accounts tab (the twin is one of the
// account's connection methods, not a separate surface). Keep the route as a
// redirect so old links and bookmarks land on the merged view.
export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/twins",
)({
  beforeLoad: () => {
    throw redirect({ to: "/account/accounts" });
  },
});
